import moment from 'moment';

export const format = (
    date: any,
    formatvalue: string = 'YYYY/MM/DD HH:mm:ss',
) => {
    if (typeof date === 'string') {
        const dateArr = date.split('-');
        const newDate = new Date(parseInt(dateArr[0]), parseInt(dateArr[1]) - 1, parseInt(dateArr[2]));
        return moment(newDate).format(formatvalue);
    } else {
        return moment(date).format(formatvalue);
    }
}

export const formatIso = (
    date: Date,
    formatValue: string = 'YYYY/MM/DD HH:mm:ss'
) => {
    return moment(date).format(formatValue);
}

export const format_one = (
    date: Date,
    formatvalue: string = 'MM/DD/YYYY HH:mm:ss',
) => (
        ( !date ) ? ('') :
                (moment(date).format(formatvalue))
);

export const format_two = (
    date: Date,
    formatvalue: string = 'YYYY-MM-DD HH:mm:ss',
) => (
        ( !date ) ? ('') :
                (moment(date).format(formatvalue))
);

// Return the minutes from two dates.
export const format_three = (
    startTime: Date,
    endTime: Date
) => {
    var min = (!startTime && !endTime) ? '0' : moment
        .duration(moment(endTime, 'YYYY/MM/DD HH:mm')
        .diff(moment(startTime, 'YYYY/MM/DD HH:mm'))
        ).asMinutes().toString();
    return min;
}

export const substract_daysoncurrentdate = (
    days: number,
    formatvalue: string = 'MM/DD/YYYY',
) => (
        ( !days ) ? (moment().format(formatvalue)) :
            (moment().subtract(days, 'days').format(formatvalue))
);
export const add_daysoncurrentdate = (
    days: number,
    formatvalue: string = 'MM/DD/YYYY',
) => (
        ( !days ) ? (moment().format(formatvalue)) :
            (moment().add(days, 'days').format(formatvalue))
);